<template>
<div>
  <div class="copyrightManageBox">
    <Row>
      <Col :span="12">
        <span>运营版权数量:</span>
        <span>{{dataList.authCopyrightNo}}</span>
      </Col>
      <Col :span="12">
        <span>运营版权名称:</span>
        <span>{{dataList.authCopyrightVendorList}}</span>
      </Col>
      <Col :span="12">
        <span>账号名称:</span>
        <span v-if='this.$route.query.type == 1'>{{dataList.accountName}}</span>
        <Input  v-if='this.$route.query.type == 0' type="text" v-model="changeData.accountName" placeholder="请输入账号名称" clearable style="width: 200px"/>
      </Col>
      <Col :span="12">
        <span>账号:</span>
        <span>{{dataList.accountCode}}</span>
      </Col>
      <Col :span="12">
        <span>密码:</span>
        <span v-if='this.$route.query.type == 1'>{{dataList.accountPwd}}</span>
        <Input  v-if='this.$route.query.type == 0' type="password" v-model="changeData.accountPwd" placeholder="请输入密码" clearable style="width: 200px"/>
      </Col>
      <Col :span="12">
        <span>所属平台:</span>
        <span>{{dataList.mediaPlatform}}</span>
      </Col>
      <Col :span="12">
        <span>粉丝数量:</span>
        <span>{{dataList.fansCount ? dataList.fansCount : "-"}}</span>
      </Col>
      <Col :span="12">
        <span>发文数量:</span>
        <span>{{dataList.essayCount ? dataList.essayCount : "-" }}</span>
      </Col>
      <Col :span="12">
        <span>账号管理开始时间:</span>
        <span>{{dataList.cooperationStartTime ? dataList.cooperationStartTime : "-"}}</span>
      </Col>
      <Col :span="12">
        <span>账号管理截止时间:</span>
        <span>{{dataList.cooperationEndTime ? dataList.cooperationEndTime : "-"}}</span>
      </Col>
      <Col :span="12">
        <span>账号昨日收入:</span>
        <span>{{dataList.yesterdayIncome ? dataList.yesterdayIncome : 0}}</span>
      </Col>
      <Col :span="12">
        <span>账号总收入:</span>
        <span>{{dataList.totalIncome ? dataList.totalIncome : 0}}</span>
      </Col>
      <Col :span="12">
        <span>所属自媒体:</span>
        <span>{{dataList.mediaName}}</span>
      </Col>
    </Row>
    <div slot="footer" style="text-align:center;margin-top:60px;padding-bottom:20px" v-if='this.$route.query.type == 0'>
        <Button type="text" @click="cansleUpdata" style="margin-right:30px">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">确认修改</Button>
    </div>
  </div>
  <div class="copyrightManageBox" style='padding:16px' v-if='this.$route.query.type==1'>
    <Row @keydown.enter.native="handleSearch" style="margin-top:5px;padding-top:20px">
      <Form id="search-form-y" ref="searchForm" :model="searchForm" inline :label-width="100" class="search-form">
        <Form-item label="平台" prop="mediaPlatform">
          <Input type="text" v-model="searchForm.mediaPlatform" placeholder="请输入发布平台" clearable style="width: 200px"/>
        </Form-item>
        <Button style="margin-left:20px;" @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
      </Form>
    </Row>
    <Row>
      <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
    </Row>
    <Row type="flex" justify="end" class="page" style="margin-top:20px">
      <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
    </Row>
  </div>
</div>
</template>

<script>

import {wemediaAccountManageDetail,wemediaAccountManageEdit} from "@/api/index";
export default {
  name: "copyright_manage_detail",
  components: {
  },
  data() {
    return {
      dataList:[],
      loading: true, // 表单加载状态
      changeData:{
          id:this.$route.query.id,
          accountName:"",
          accountPwd:""
      },
      searchForm:{
        copyrightName:this.$route.query.name,
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "create_time", // 默认排序字段
        order: "desc", // 默认排序方式
        copyrightType:'版权方统计分析账号1',
      },
      columns: [
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "标题",
          key: "title",
          minWidth: 120,
          sortable: false,
          render: (h, params) => {
            return h("div", [
              h("a",
                {
                  on: {
                    click: () => {
                      this.goUrl(params.row.linkUrl);
                    }
                  }
                },
                params.row.title
              )
            ])
          }
        },
        {
          title: "发布平台",
          key: "mediaPlatform",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "自媒体账号",
          key: "wemediaAccountCode",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "播放量",
          key: "playCount",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "版权名",
          key: "copyrightName",
          minWidth: 120,
          sortable: false,
        },
      ],
      data: [], // 表单数据
      total: 0 ,// 表单数据总数
      copyrightVendorNameD:'版权方统计分析账号1',
      copyrightNameD:'哪吒降魔',
    };
  },
  methods: {
    init() {
      this.getDataList();
      this.getDataListTable();
    },
    goUrl(url){
      window.open(url,'_blank')
    },
    cansleUpdata(){
        let query = { id:this.$route.query.wemediaId};
        this.$router.push({
            name: "wemedia_manage_detail",//详情页面
            query: query
        });
    },
    copyTypeChange(v){
      this.copyrightVendorNameD = v.value
      this.copyrightNameD = v.label
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataListTable();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataListTable();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataListTable();
    },
    getDataListTable() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
      this.getRequest("/incomeAnalyse/getByPage", this.searchForm).then(res => {
        this.loading = false;
        if (res.success) {
          this.data = res.result.records;
          this.total = res.result.total;
        }
      });
      this.total = this.data.length;
      this.loading = false;
    },
    handleSubmit(){
      let formData = new FormData()
          formData.append("id",this.$route.query.id)
          formData.append("accountName",this.changeData.accountName)
          formData.append("accountPwd",this.changeData.accountPwd)
        wemediaAccountManageEdit(formData).then(res=>{
            console.log(res)
            if(res.success){
                this.$Message.success("修改成功");
                let query = { id:this.$route.query.wemediaId};
                if(this.$route.query.wemediaId){
                    this.$router.push({
                        name: "wemedia_manage_detail",//详情页面
                        query: query
                    });
                }else{
                    this.$router.push({
                        name: "wemedia-account-manage",//详情页面
                        query: query
                    });
                }
            }
        })
    },
    //获取详情页详细信息
    getDataList() {
      this.loading = true;
     wemediaAccountManageDetail(this.$route.query.id).then(res => {
       console.log(res)
       if(res.success){
         this.dataList = res.result;
         this.changeData.accountName = res.result.accountName;
         this.changeData.accountPwd = res.result.accountPwd
       }
     })
      this.loading = false;
    },
    
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
    .copyrightManageBox{
      background: #fff;
    border-radius: 4px;
    margin-bottom: 5px;
        .ivu-row{
            line-height: 40px;
            .ivu-col{
                span:nth-of-type(1){
                    width: 115px;
                    display: inline-block;
                    text-align: right;
                }
                span:nth-of-type(2){
                    margin-left:15px;
                }
            }
        }
    }

</style>